// SMS Configuration
export const SMS_SENDER_PHONE = '+1(440) 581.8253';

export const getSmsComplianceFooter = (providerName: string): string =>
  `JotPsych on behalf of ${providerName}. Reply STOP to opt out; HELP for help`;
